(function() {
    'use strict';

    angular
        .module('sideApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
        .state('revision', {
            parent: 'app',
            url: '/revsionreporte?page&sort&search&type',
            data: {
            	authorities: ['RESPONSABLE_SIDE'],
                pageTitle: 'Revision reporte Evaluativo'
            },
            views: {
                'content@': {
                    templateUrl: 'app/reportes/revision/misrevisionesevaluativos.html',
                    controller: 'RevisionEvaluativosController',
                    controllerAs: 'vm'
                }
            },
            params: {
                page: {
                    value: '1',
                    squash: true
                },
                sort: {
                    value: 'id,asc',
                    squash: true
                },
                search: null,
                type: '1',
                indice : '1',
                ic : false,
                iic : '0',
                anio: '0',
                aniostr: '',
                modelo: '0',
                nivel: '0',
                centro: '0',
                ep: false
                
            },
            resolve: {
                pagingParams: ['$stateParams', 'PaginationUtil', function ($stateParams, PaginationUtil) {
                    return {
                        page: PaginationUtil.parsePage($stateParams.page),
                        sort: $stateParams.sort,
                        predicate: PaginationUtil.parsePredicate($stateParams.sort),
                        ascending: PaginationUtil.parseAscending($stateParams.sort),
                        search: $stateParams.search,
                        type: $stateParams.type,
                        indice: $stateParams.indice,
                        ic : $stateParams.ic,
                        iic : $stateParams.iic,
                        anio: $stateParams.anio,
                        aniostr: $stateParams.aniostr,
                        modelo: $stateParams.modelo,
                        nivel: $stateParams.nivel,
                        centro: $stateParams.centro,
                        ep: $stateParams.ep
                    };
                }]
            }
        })
        .state('revisionReporteOO', {
            parent: 'revision',
            url: '/revisionreporteoo/{id}',
            data: {
            	authorities: ['RESPONSABLE_SIDE'],
                pageTitle: 'Reporte Evaluativo'
            },
            views: {
                'content@': {
                    templateUrl: 'app/reportes/reporteevaluativoOO/reporteevaluativoOO.html',
                    controller: 'ReporteEvaluativoOOController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                entity: ['$stateParams', 'RevisionReporteOyOService','$state', function($stateParams, RevisionReporteOyOService,$state) {
              	  return RevisionReporteOyOService.get({id: $stateParams.id}).$promise;
                }]
            },
        })
		.state('revisionReporteLic', {
		    parent: 'revision',
		    url: '/revisionreporteLic/{id}',
		    data: {
		        authorities: ['RESPONSABLE_SIDE'],
		        pageTitle: 'Reporte Evaluativo'
		    },
		    views: {
		        'content@': {
		            templateUrl: 'app/reportes/reporteevaluativoLic/reporteevaluativoLic.html',
		            controller: 'ReporteEvaluativoLicController',
		            controllerAs: 'vm'
		        }
		    },
		    resolve: {
		        entity: ['$stateParams', 'ReporteEvaluativoLicService','$state', function($stateParams, ReporteEvaluativoLicService,$state) {
		          return ReporteEvaluativoLicService.getRevision({id: $stateParams.id}).$promise;
		        }]
		    },
		})
        .state('revisionReporteLI', {
            parent: 'revision',
            url: '/revisionreporteli/{id}',
            data: {
            	authorities: ['RESPONSABLE_SIDE'],
                pageTitle: 'Reporte Evaluativo'
            },
            views: {
                'content@': {
                    templateUrl: 'app/reportes/reporteevaluativoLI/reporteevaluativoLI.html',
                    controller: 'ReporteEvaluativoLIController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                entity: ['$stateParams', 'RevisionReporteLibreService','$state', function($stateParams, RevisionReporteLibreService,$state) {
              	  return RevisionReporteLibreService.get({id: $stateParams.id}).$promise;
                }]
            },

        })
        .state('revisionReporteCU', {
            parent: 'revision',
            url: '/revisionreportecu/{id}',
            data: {
            	authorities: ['RESPONSABLE_SIDE'],
                pageTitle: 'Reporte Evaluativo'
            },
            views: {
                'content@': {
                    templateUrl: 'app/reportes/reporteevaluativoCU/reporteevaluativoCU.html',
                    controller: 'ReporteEvaluativoCUController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                entity: ['$stateParams', 'ReporteEvaluativoCUService','$state', function($stateParams, ReporteEvaluativoCUService,$state) {
              	  return ReporteEvaluativoCUService.getRevision({id: $stateParams.id}).$promise;
                }]
            },
        })
        .state('revisionReporteRegular', {
            parent: 'revision',
            url: '/revisionreporteregular/{id}',
            data: {
            	authorities: ['RESPONSABLE_SIDE'],
                pageTitle: 'Reporte Evaluativo'
            },
            views: {
                'content@': {
                    templateUrl: 'app/reportes/reporteevaluativoRegular/reporteevaluativoRegular.html',
                    controller: 'ReporteEvaluativoRegularController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                entity: ['$stateParams', 'ReporteEvaluativoRegularService','$state', function($stateParams, ReporteEvaluativoRegularService,$state) {
              	  return ReporteEvaluativoRegularService.getRevision({id: $stateParams.id}).$promise;
                }]
            },
        })
        .state('revisionReporteVirtual', {
            parent: 'revision',
            url: '/revisionreportevirtual/{id}',
            data: {
            	authorities: ['RESPONSABLE_SIDE'],
                pageTitle: 'Reporte Evaluativo'
            },
            views: {
                'content@': {
                    templateUrl: 'app/reportes/reporteevaluativoVirtual/reporteevaluativoVirtual.html',
                    controller: 'ReporteEvaluativoVirtualController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                entity: ['$stateParams', 'ReporteEvaluativoVirtualService','$state', function($stateParams, ReporteEvaluativoVirtualService,$state) {
              	  return ReporteEvaluativoVirtualService.getRevision({id: $stateParams.id}).$promise;
                }]
            },
        })
        .state('revisionReporteUAEV', {
            parent: 'revision',
            url: '/revisionreporteuaev/{id}',
            data: {
            	authorities: ['RESPONSABLE_SIDE'],
                pageTitle: 'Reporte Evaluativo'
            },
            views: {
                'content@': {
                    templateUrl: 'app/reportes/reporteevaluativoUAEV/reporteevaluativoUAEV.html',
                    controller: 'ReporteEvaluativoUAEVController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                entity: ['$stateParams', 'ReporteEvaluativoUAEVService','$state', function($stateParams, ReporteEvaluativoUAEVService,$state) {
              	  return ReporteEvaluativoUAEVService.getRevision({id: $stateParams.id}).$promise;
                }]
            },
        })
		.state('revisionReporteBachillerato', {
		    parent: 'revision',
		    url: '/revisionreporteBachillerato/{id}',
		    data: {
		    	authorities: ['RESPONSABLE_SIDE'],
		        pageTitle: 'Reporte Evaluativo'
		    },
		    views: {
		        'content@': {
		            templateUrl: 'app/reportes/reporteevaluativoBachillerato/reporteevaluativoBachillerato.html',
		            controller: 'ReporteEvaluativoBachilleratoController',
		            controllerAs: 'vm'
		        }
		    },
		    resolve: {
		        entity: ['$stateParams', 'ReporteEvaluativoBachilleratoService','$state', function($stateParams, ReporteEvaluativoBachilleratoService,$state) {
		      	  return ReporteEvaluativoBachilleratoService.getRevision({id: $stateParams.id}).$promise;
		        }]
		    },
		})
		.state('revisionReporteMixtoPII', {
		    parent: 'revision',
		    url: '/revisionreporteMixtoPII/{id}',
		    data: {
		    	authorities: ['RESPONSABLE_SIDE'],
		        pageTitle: 'Reporte Evaluativo'
		    },
		    views: {
		        'content@': {
		            templateUrl: 'app/reportes/reporteevaluativoMixtoPII/reporteevaluativoMixtoPII.html',
		            controller: 'ReporteEvaluativoMixtoPIIController',
		            controllerAs: 'vm'
		        }
		    },
		    resolve: {
		        entity: ['$stateParams', 'ReporteEvaluativoMixtoPIIService','$state', function($stateParams, ReporteEvaluativoMixtoPIIService,$state) {
		      	  return ReporteEvaluativoMixtoPIIService.getRevision({id: $stateParams.id}).$promise;
		        }]
		    },
		})
    }

})();
